import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Card, CardContent } from "@mui/material";
import { LineChart, BarChart } from "@mui/x-charts";
import { fetchDashboardAnalytics, fetchSalesTrends, fetchTopProducts } from "../api/analyticsApi";

const AnalyticsOverview = () => {
  const [salesData, setSalesData] = useState([]);
  const [topProducts, setTopProducts] = useState([]);
  const [dashboardData, setDashboardData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const analytics = await fetchDashboardAnalytics();
        const trends = await fetchSalesTrends();
        const products = await fetchTopProducts();

        setDashboardData(analytics);
        setSalesData(trends);
        setTopProducts(products);
      } catch (error) {
        console.error("Error fetching analytics data:", error);
      }
    };

    fetchData();
  }, []);

  if (!dashboardData) return <Typography>Loading...</Typography>;

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Analytics Overview
      </Typography>

      <Grid container spacing={3}>
        {/* Sales Trends */}
        <Grid  size={{xs: 12, md: 8}}>
          <Card>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Sales Trends
              </Typography>
              <LineChart
                xAxis={[{ dataKey: "date", scaleType: "time" }]}
                series={[{ dataKey: "sales", label: "Sales" }]}
                dataset={salesData}
                height={300}
              />
            </CardContent>
          </Card>
        </Grid>

        {/* Top Selling Products */}
        <Grid size={{xs: 12, md: 4}}>
          <Card>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Top Selling Products
              </Typography>
              <BarChart
                xAxis={[{ dataKey: "product_name", scaleType: "band" }]}
                series={[{ dataKey: "total_sold", label: "Sales" }]}
                dataset={topProducts}
                height={300}
              />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AnalyticsOverview;